import s from './SigningSection.scss';

type GenericSigningButtonProps = {
  text: string;
  href: string;
  classNames: string[];
  dataHook?: string;
  isMobile?: boolean;
};
export const SigningButton = ({ classNames, text, href, isMobile, dataHook }: GenericSigningButtonProps) => {
  const finalClassName = classNames.concat(isMobile ? s.mobileOnly : s.desktopOnly).join(' ');
  return `
    <a
      class="${finalClassName}"
      href="${href}"
      data-hook="${dataHook}"
    >
      ${text}
    </a>
`;
};
